/*=========================================================================================
  File Name: restaurants.js
  Description: Restaurant Local Storage
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

function storeCurrentRestaurant(restaurantid) {
    console.log('store CurrentRestaurant is called!')
    localStorage.setItem('currentRestaurant', JSON.stringify(restaurantid));
}

function getCurrentRestaurant() {
    let id = localStorage.getItem('currentRestaurant');
    return JSON.parse(id);
}

function clearCurrentRestaurant() {
    localStorage.removeItem("currentRestaurant");
}

export default {
    storeCurrentRestaurant,
    getCurrentRestaurant,
    clearCurrentRestaurant

}